import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales February 2026 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13)
const jobData = [
  {
    jobInfo: "E-889: Tabor Design Build",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 392.20,
    grossMarginPct: 0.3000,
    grossProfit: 117.66,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 392.20 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-874: Aion Management The Ridge",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 20284.00,
    grossMarginPct: 0.3777,
    grossProfit: 7661.27,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 20284.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-862: Ballard Green Condominium 1",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 1999.00,
    grossMarginPct: 0.6248,
    grossProfit: 1248.98,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1999.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-891: Siman Builds Nelson Residence",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 1940.00,
    grossMarginPct: 0.4794,
    grossProfit: 930.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1940.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-872: Pennrose Management Square at Merritt Mill",
    leadSource: "Referral- Cody's network",
    trade: "Miscellaneous",
    contractTotal: 12600.00,
    grossMarginPct: 0.4383,
    grossProfit: 5522.58,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12600.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-877: Ballard Green Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 2200.00,
    grossMarginPct: 0.3000,
    grossProfit: 660.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2200.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-863: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 31996.75,
    grossMarginPct: 0.2708,
    grossProfit: 8664.72,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 31996.75 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-880: Solution Based Property Management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 740.00,
    grossMarginPct: 0.3000,
    grossProfit: 222.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 740.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-840: Tabor Victory Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 29748.75,
    grossMarginPct: 0.5143,
    grossProfit: 15299.78,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 29748.75 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesFebruary2026Data: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 2,
    year: 2026
  }
};
